const axios = require('axios')
const codeUrl = process.env.REACT_APP_HOST_API + '/codes'
const sessionUrl = process.env.REACT_APP_HOST_API + '/sessions'

export const getCodeById = async (id) => {
  if (!id)
    return null

  let res = await axios.get(codeUrl + '/' + id)
    .catch(error => {
      console.error(error)
    })
  if(res?.data?.code===undefined){
    return false
  }
  return res.data.code
}
export const getCodeByUserId = async (id) => {
  if (!id)
    return null

  let res = await axios.get(codeUrl + '/user/' + id)
    .catch(error => {
      console.error(error)
    })
  if(res?.data?.code===undefined){
    return false
  }
  return res.data.code
}

export const getAllCodeByUserId = async (id) => {
  if (!id) return [];

  try {
    const res = await axios.get(codeUrl + '/user/' + id);
    console.log('🔍 getAllCodeByUserId response:', res.data);
    
    // Response is now { codes: [...] }
    if (res?.data?.codes && Array.isArray(res.data.codes)) {
      return res.data.codes;
    }
    
    // Fallback for old format
    if (res?.data && Array.isArray(res.data)) {
      return res.data;
    }
    if (res?.data?.id) {
      return [res.data];
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching all code:', error);
    return [];
  }
}

export const getCodesBySessionAndUser = async (sessionId, userId) => {
  if (!userId) return [];

  try {
    // Using /user/:id endpoint since session_id column doesn't exist yet
    const res = await axios.get(`${codeUrl}/user/${userId}`);
    console.log('🔍 getCodesBySessionAndUser response:', res.data);
    
    // Response format is { codes: [...] }
    if (res?.data?.codes && Array.isArray(res.data.codes)) {
      return res.data.codes;
    }
    
    // Fallback formats
    if (res?.data?.code && Array.isArray(res.data.code)) {
      return res.data.code;
    }
    if (res?.data && Array.isArray(res.data)) {
      return res.data;
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching codes by session and user:', error);
    return [];
  }
}

export const getCodesByIds= async (ids) => {
  if (!ids || ids.length===0)
    return null

  let res = await axios.post(codeUrl + "/ids",{ids: ids})
  .catch(error => {
    console.error(error)
  })
  console.log(res)
  if(res?.data===undefined){
    return false
  }
  return res.data.code
}

export const addCode = async (content, passrate, userId) => {
  if (!content || content === "" || !userId) {
    return false
  }

  axios.post(codeUrl + '/', {
    code: {
      creater_id: userId,
      content: content,
      passrate: passrate ? passrate : 0,
      created_time: new Date(),
    }
  })
}

//'save' button
export const addCodeAndUpdateUser = async (
  content,
  passrate,
  userId,
  keystrokes
) => {
  console.log(content,userId)
  if (content==null || !userId) {
    return false
  }

  let res = {}
  res.success = false
  let response = await axios.post(codeUrl + '/user/' + userId, {
    code: {
      creater_id: userId,
      content: content,
      passrate: passrate ? passrate : 0,
      created_time: new Date(),
      keystrokes: keystrokes
    },
  })
    .catch(error => {
      console.error(error)
    })
  res.code = response.data.code
  res.success = true
  //console.log(res)
  return res
}

export const searchCodesBySession = async (sessionId, target) => {
  try {
    const res = await axios.post(sessionUrl + '/' + sessionId + '/codes', {
      target: target
    })
    //console.log(res.data)
    return res.data.codes
  } catch (error) {
    console.error(error)
    return []
  }
}

export const runCode = async (code1, code2, type,session_id) => {
  if (code1==null || code2==null|| !type) {
    return -1
  }
  try {
    let res = await axios.post(codeUrl + '/run/'+session_id, {
      code1: code1,
      code2: code2,
      type: type
    })
    console.log(res)
    return res.data.code
    
  } catch (error) {
    console.log(error)
    
  }
  
}

export const getSchemaBySessionId = async (session_id) => {
  if (!session_id) {
    return -1
  }
  try {
    let res = await axios.get(codeUrl + '/schema/'+session_id)
    console.log(res)
    return res.data.code
    
  } catch (error) {
    console.log(error)
    
  }
  
}

export const runJava= async (code,session_id) => {
  if (code==null) {
    return -1
  }
  try {
    let res = await axios.post(codeUrl + '/runJava/'+session_id, {
      code: code
    })
    console.log(res)
    return res.data.code
    
  } catch (error) {
    console.log(error)
    
  }
  
}

// withHarness (optional): true / false force the session's test harness on / off - the
// instructor's test validation (always on) and the creation wizard's live preview (the
// test switch as drafted). Student runs leave it out, so the server follows
// session.enable_tests. Off is sent as `skipHarness`, a field older builds never send
// (they post `withHarness: false` meaning "follow the session").
export const runCPP= async (code,session_id,{ withHarness } = {}) => {
  if (code==null) {
    return -1
  }
  try {
    let res = await axios.post(codeUrl + '/runCPP/'+session_id, {
      code: code,
      ...(withHarness === true ? { withHarness: true } : withHarness === false ? { skipHarness: true } : {}),
      // This client reads "VIZPI:" result lines (testResults.js parseCppHarness), so the
      // backend may upgrade an old saved harness to per-test isolation.
      markedResults: true,
    })
    console.log(res)
    return res.data.code
    
  } catch (error) {
    console.log(error)
    
  }
  
}